const BIN_REGEX = /^[\d]{7}-[\d]$/;

const getChecksum = (bin: string): number => {
  const MULTIPS = [7, 9, 10, 5, 8, 4, 2];

  let sum = 0;
  for (let i = 0; i < bin.length; i++) {
    sum += parseInt(bin[i], 10) * MULTIPS[i];
  }
  let remainder = sum % 11;
  if (remainder === 1) {
    return -1;
  } else if (remainder > 1) {
    remainder = 11 - remainder;
  }

  return remainder;
};

export const isBinOk = (bin: string): boolean => {
  if (BIN_REGEX.test(bin)) {
    return (
      parseInt(bin.substring(8, 9), 10) === getChecksum(bin.substring(0, 7))
    );
  }
  return false;
};
